import React, { type FC, useMemo } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  modalCopyCancelCallback,
  modalCopyNextStepCallback,
} from 'Pages/GroupsList/recoil/callbacks/modals'
import {
  modalCopyDisableGoNextSelector,
  modalCopyState,
} from 'Pages/GroupsList/recoil/state/state'
import {
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Button,
  Modal,
  ModalFoot,
  Spinner,
} from 'mailup-web-components'
import ModalCopyConfirmStep from './ModalCopyConfirmStep'
import ModalCopyFormStep from './ModalCopyFormStep'

const ModalCopyToList: FC = () => {
  const intl = useIntl()

  const { show, step, nameValidLoading } = useRecoilValue(modalCopyState)
  const disableGoNext = useRecoilValue(modalCopyDisableGoNextSelector)

  const modalCancel = useRecoilCallback(modalCopyCancelCallback, [])
  const modalConfirm = useRecoilCallback(modalCopyNextStepCallback, [])

  return (
    <Modal show={show} onClose={modalCancel}>
      {step === 'form' && <ModalCopyFormStep />}
      {step === 'confirm' && <ModalCopyConfirmStep />}
      <ModalFoot>
        <Button
          kind={BUTTON_VARIANT_SECONDARY}
          onClick={modalCancel}
          data-mu-test="modal-copy__close"
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
        </Button>
        <Button
          kind={BUTTON_VARIANT_PRIMARY}
          onClick={modalConfirm}
          disabled={disableGoNext}
          data-mu-test="modal-copy__next"
        >
          {step === 'confirm' ? (
            intl.formatMessage({ id: 'Load.MailupCommon.Confirm' })
          ) : (
            <>
              {intl.formatMessage({ id: 'Load.CopyGroupToList.NextStep' })}
              {nameValidLoading && (
                <>
                  {' '}
                  <Spinner />
                </>
              )}
            </>
          )}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

export default ModalCopyToList
